export default __webpack_public_path__ + "static/preview-cd1e14389329b3b6876b089c7ecbe186.jpg";